import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-52b6617c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "timeline-scroll-container" }
const _hoisted_2 = ["disabled"]
const _hoisted_3 = { class: "timeline" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "timeline-arrow start" }, null, -1))
const _hoisted_5 = ["onMouseenter"]
const _hoisted_6 = { class: "timeline-node" }
const _hoisted_7 = { class: "timeline-content" }
const _hoisted_8 = { class: "timeline-time" }
const _hoisted_9 = { class: "timeline-title" }
const _hoisted_10 = { class: "timeline-duration" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "timeline-arrow end" }, null, -1))
const _hoisted_12 = ["disabled"]

import { ref, onMounted, onUnmounted } from 'vue';

interface TimelineItem {
  title: string;
  time: string;
  duration: string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'TimelineHorizontal',
  props: {
    timelineData: {}
  },
  setup(__props: any) {

const props = __props;

const timelineWrapper = ref<HTMLElement | null>(null);
const canScrollLeft = ref(false);
const canScrollRight = ref(true);

const activeIndex = ref<number>(-1);

const isConnectorActive = (index: number): boolean => {
  return activeIndex.value === index || activeIndex.value === index - 1;
};

const scroll = (direction: number) => {
  if (!timelineWrapper.value) return;

  const scrollAmount = timelineWrapper.value.clientWidth * 0.8;
  timelineWrapper.value.scrollBy({
    left: direction * scrollAmount,
    behavior: 'smooth'
  });
};

const getMiniute = (seconds: number) => {
  // seconds单位是秒，如果大于1小时，显示x h x min，如果小于1小时，显示x min， 如果小于1min 显示x s
  if(seconds >= 3600) {
    return Math.floor(seconds / 3600) + '小时' + ' ' + Math.floor((seconds % 3600) / 60) + '分';
  } else if(seconds >= 60) {
    return Math.floor(seconds / 60) + '分' + ' ' + Math.floor((seconds % 60) / 60) + '秒';
  } else if(seconds >= 0) {
    return Math.floor(seconds) + '秒';
  }
}

const checkScrollPosition = () => {
  console.log('111111111111111111111111111111111')
  if (!timelineWrapper.value) return;

  const { scrollLeft, scrollWidth, clientWidth } = timelineWrapper.value;
  canScrollLeft.value = scrollLeft > 0;
  canScrollRight.value = scrollLeft < scrollWidth - clientWidth - 1; // -1 避免小数误差
};

onMounted(() => {
  if (timelineWrapper.value) {
    timelineWrapper.value.addEventListener('scroll', checkScrollPosition);
    // 初始检查
    checkScrollPosition();
  }
});

onUnmounted(() => {
  if (timelineWrapper.value) {
    timelineWrapper.value.removeEventListener('scroll', checkScrollPosition);
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("button", {
      class: "scroll-arrow left",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (scroll(-1))),
      disabled: !canScrollLeft.value
    }, " ◀ ", 8, _hoisted_2),
    _createElementVNode("div", {
      class: "timeline-wrapper",
      ref_key: "timelineWrapper",
      ref: timelineWrapper
    }, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.timelineData, (item, index) => {
          return (_openBlock(), _createElementBlock("div", {
            key: index,
            class: "timeline-item",
            onMouseenter: ($event: any) => (activeIndex.value = index),
            onMouseleave: _cache[1] || (_cache[1] = ($event: any) => (activeIndex.value = -1))
          }, [
            (index > 0)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: _normalizeClass(["timeline-connector", { active: isConnectorActive(index) }])
                }, null, 2))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", {
                class: _normalizeClass(["timeline-dot", { active: activeIndex.value === index }])
              }, null, 2),
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, _toDisplayString(item.accessTime), 1),
                _createElementVNode("div", _hoisted_9, _toDisplayString(item.channel), 1),
                _createElementVNode("div", _hoisted_10, _toDisplayString(getMiniute(item.duration)), 1)
              ])
            ])
          ], 40, _hoisted_5))
        }), 128)),
        _hoisted_11
      ])
    ], 512),
    _createElementVNode("button", {
      class: "scroll-arrow right",
      onClick: _cache[2] || (_cache[2] = ($event: any) => (scroll(1))),
      disabled: !canScrollRight.value
    }, " ▶ ", 8, _hoisted_12)
  ]))
}
}

})